import React, {Component} from 'react';
import fuiouLogoImg from '../../assets/images/s_pro9.gif';
import fuiouParkImg from '../../assets/images/s_pro10.gif';

export default class About extends Component{
    constructor(props) {
        super(props);
        this.state = {
            activeTabIdx: 0,
            tabs: ['企业介绍'],
        }
    }
    renderTab() {
        return this.state.tabs.map((item,idx) => {
            return <li key={idx} 
                        className={idx === this.state.activeTabIdx ? 'active' : ''}
                        onClick={() => this.tabClick(idx)}    
                    >
                        {item}
                    </li>
        })
    }
    tabClick(idx){
        this.setState({
            activeTabIdx: idx
        });
    }
    render() {
        return (
            <div className="content about">
                <div className="left">
                    <ul id="tab">
                        {this.renderTab()}
                    </ul>
                </div>
                <div className="right">
                    <div id="introduce" className={this.state.activeTabIdx === 0 ? 'active' : ''}>
                        <div className="img_wrapper">
                            <img className="float_right" src={fuiouLogoImg} alt="" />
                        </div>
                        <div className="cont">
                            <p>上海富友电子商务有限公司设立于上海自贸区，系上海富友金融服务集团股份有限公司全资子公司。</p>
                            <p>上海富友电子商务有限公司旨在通过推广“智能快递柜”项目建立起一个围绕居民社区、大学校区、企业园区的综合性的生活服务平台。</p>
                        </div>
                        <img className="m_top" src={fuiouParkImg} alt="" />
                    </div>
                </div>
            </div>
        )
    }
}